import { parseQuery } from "./parseQuery";

export function getAuthenticationStateFromQuery() {
    return parseQuery(globalThis?.location?.search);
}
